import { ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core'
import { Router } from '@angular/router'
import { LoadingService } from 'src/services/common/loading.service'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AppComponent {
  title = 'expense-automation-engine-ui'
  loading$ = this.loader.loading$

  constructor(public loader: LoadingService, private router: Router, private cdr: ChangeDetectorRef) {}

  showHeader(): boolean {
    const path = this.router.url.split('?')[0]
    return path !== '/login'
  }

  ngAfterViewInit() {
    this.loading$.subscribe(() => {
      this.cdr.detectChanges()
    })
  }
}
